import { useQuery } from "react-query";
import { getStaff } from "../utils/api";

const useStaff = () => {
  const { data, isLoading, isError, refetch } = useQuery(
    "staff",
    getStaff,
    { refetchOnWindowFocus: false, retry: 1 }
  );

  return {
    data: data ?? [],
    isError,
    isLoading,
    refetch,
  };
};

export default useStaff;
